<div [class]="wrapperClass()">
  <span class="bz-input__affix"><ng-content select="[bzInputPrefix]" /></span>
  <input
    class="bz-input__field"
    [type]="type()"
    [value]="value()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readOnly]="readonly()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-label]="ariaLabel() || null"
    (input)="onInput($event)"
    (blur)="markTouched()"
  />
  <span class="bz-input__affix"><ng-content select="[bzInputSuffix]" /></span>
</div>
